import { createContext, use } from 'react';

type NavigationContextValue = {
  isCollapsed: boolean;
  showLabels: boolean;
  toggleCollapsed: () => void;
};

export const NavigationContext = createContext<NavigationContextValue | null>(null);

export const useNavigationContext = () => {
  const context = use(NavigationContext);

  if (!context) {
    throw new Error('Navigation compound components must be used inside Navigation.Root');
  }

  return context;
};
